export default {
  path: 'aggregator/solutions',
  name: 'Aggregator_solutions',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/AggregatorSolutionsMain')
}
